export interface ICommonState {
  isLoading: boolean
  loadingStack: TLoadingStackProps
  loaderProps?: TLoaderProps
  appVersion?: string
  appBuildDate?: string
}

export type TLoaderProps = {
  isFileUpload?: boolean
  message?: string
}

export type TLoadingStackProps = {
  pendingItemsLoading: number
}

export enum FETCH_STATUS {
  REQUEST_STARTED = 'REQUEST_STARTED',
  REQUEST_FINISHED = 'REQUEST_FINISHED'
}
